
namespace GeniuzPOS.SalePromoCamp {
    import fld = PsPromoApHdRow.Fields
        @Serenity.Decorators.registerClass()
        export class PsPromoApHdGrid extends Serenity.EntityGrid<PsPromoApHdRow, any> {
            protected getColumnsKey() { return PsPromoApHdColumns.columnsKey; }
            protected getDialogType() { return PsPromoApHdDialog; }
            protected getIdProperty() { return PsPromoApHdRow.idProperty; }
            protected getInsertPermission() { return PsPromoApHdRow.insertPermission; }
            protected getLocalTextPrefix() { return PsPromoApHdRow.localTextPrefix; }
            protected getService() { return PsPromoApHdService.baseUrl; }
    
            constructor(container: JQuery) {
                super(container);
            }
            protected getButtons() {
                var buttons = super.getButtons();
    
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
                
                buttons.push(
                    {
                        title: Q.text("Close"), // *** Get button text from translation
                        cssClass: '.panel-titlebar-close',
                        icon: 'fa-close',
                        onClick: () => {
                            window.location.href = '/';
                            return false;
                        },
                    }
                );            
                return buttons;
            }
            protected createToolbarExtensions() {
                super.createToolbarExtensions();
        
                this.slickGrid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());
                    
                var groupingMixin = new Serenity.DraggableGroupingMixin({
                    grid: this
                });
        
                // setting ShipCountry, ShipCity columns as initially grouped for this sample
                // you could add [GroupOrder(1)] to ShipCountry, and [GroupOrder(2)] to ShipCity
                // in OrderColumns.cs instead (recommended way)
                groupingMixin.plugin.setDroppedGroups(["  "]);
            }
            protected getSlickOptions() {
                var opt = super.getSlickOptions();
                // need to turn grouping panel ON for drag drop grouping to work properly
                opt.groupingPanel = true;
                return opt;
            }
            // protected getQuickFilters(): Serenity.QuickFilter<Serenity.Widget<any>, any>[] {
    
            //     // let filters = super.getQuickFilters();
            //     // Q.first(filters, x => x.field == fld.PromoApproveFg).init = w => {
            //     //     (w as Serenity.EnumEditor).value = "0";
            //     //     ;
            //     // };
            //     // Q.first(filters, x => x.field == fld.PromoStatus).init = w => {
            //     //     (w as Serenity.EnumEditor).value = "0";
            //     //      ;
            //     // };   
                
                
            //     return filters;
            // }
        }
    }